module.exports = __webpack_public_path__ + "static/media/5DPO2.7e64f6e9.jpg";